module.exports = "<app-bulk-renewal [proposalID]=\"proposalID\" [isEditable]=\"false\"></app-bulk-renewal>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/account-client/component/account-client-details/proposal-view-modal/rv-proposal-vew/rv-proposal-vew.component.html
// module id = ./src/app/account-client/component/account-client-details/proposal-view-modal/rv-proposal-vew/rv-proposal-vew.component.html
// module chunks = main